export type SolutionMapView = 'industry' | 'topic';

interface SolutionMapToolbarProps {
  view: SolutionMapView;
  editMode: boolean;
  onToggleView: () => void;
  onToggleEdit?: () => void;
  onAddTopic?: () => void;
  selectedIndustry: string;
  onIndustryChange: (value: string) => void;
  industryOptions: string[];
  searchQuery: string;
  onSearchChange: (value: string) => void;
}

export default function SolutionMapToolbar({
  view,
  editMode,
  onToggleView,
  onToggleEdit,
  onAddTopic,
  selectedIndustry,
  onIndustryChange,
  industryOptions,
  searchQuery,
  onSearchChange,
}: SolutionMapToolbarProps) {
  return (
    <div className="ivt-sm-toolbar">
      <div className="ivt-sm-toolbar__row">
        <div className="ivt-sm-toolbar__segment">
          <button
            type="button"
            className={
              'ivt-sm-toolbar__seg-btn' +
              (view === 'industry' ? ' ivt-sm-toolbar__seg-btn--active' : '')
            }
            onClick={view === 'topic' ? onToggleView : undefined}
            disabled={editMode}
          >
            View by Industry
          </button>
          <button
            type="button"
            className={
              'ivt-sm-toolbar__seg-btn' +
              (view === 'topic' ? ' ivt-sm-toolbar__seg-btn--active' : '')
            }
            onClick={view === 'industry' ? onToggleView : undefined}
            disabled={editMode}
          >
            View by Topic
          </button>
        </div>

        {view === 'industry' && (
          <>
            <div className="ivt-sm-toolbar__select">
              <span className="ivt-sm-toolbar__select-label">Industry</span>
              <select
                className="ivt-sm-toolbar__select-input"
                value={selectedIndustry}
                onChange={(e) => onIndustryChange(e.target.value)}
              >
                <option value="ALL">All</option>
                {industryOptions.map((ind) => (
                  <option key={ind} value={ind}>
                    {ind}
                  </option>
                ))}
              </select>
            </div>

            <div className="ivt-sm-toolbar__select">
              <span className="ivt-sm-toolbar__select-label">Time Dimension</span>
              <select className="ivt-sm-toolbar__select-input" disabled>
                <option>2026</option>
              </select>
            </div>

            <div className="ivt-sm-toolbar__search">
              <svg className="ivt-sm-toolbar__search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M11.5 11.5L14.5 14.5M7.5 13C4.46243 13 2 10.5376 2 7.5C2 4.46243 4.46243 2 7.5 2C10.5376 2 13 4.46243 13 7.5C13 10.5376 10.5376 13 7.5 13Z" stroke="#8C8C94" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
              <input
                type="text"
                className="ivt-sm-toolbar__search-input"
                placeholder="Search Use Case"
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
              />
            </div>
          </>
        )}

        {view === 'topic' && onToggleEdit && !editMode && (
          <button
            type="button"
            className="ivt-sm-toolbar__edit-btn"
            onClick={onToggleEdit}
          >
            Edit
          </button>
        )}

        {view === 'topic' && editMode && (
          <div className="ivt-sm-toolbar__edit-actions">
            <button
              type="button"
              className="ivt-sm-toolbar__outline-action-btn"
              onClick={onAddTopic}
            >
              加Topic
            </button>
            <button
              type="button"
              className="ivt-sm-toolbar__done-btn"
              onClick={onToggleEdit}
            >
              Done
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
